import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService, TreeNode } from "primeng/api";
import { UserService } from "../../../../../shared";
import { MenuService } from "../../../../master/services";
import { SysAdminService } from "../../../services/sysadmin.service";

@Component({
	selector: "caass-manage-application-items",
	templateUrl: "./manage-application-items.component.html",
	styleUrls: ["./manage-application-items.component.css"],
})
export class ManageApplicationItemsComponent implements OnInit {
	constructor(
		private menuService: MenuService,
		private confirmationService: ConfirmationService,
		private sysAdminService: SysAdminService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.LoadApplicationItems();
	}

	ngOnChanges() {
		this.UpdateAppItems();

		// console.log("DisableControls");
		// console.log(this.DisableControls);
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////

	user: any;

	@Input() AppItemsFromMain: any;
	@Input() DisableControls: any = false;

	SelectedAppItem: any;

	ApplicationItems: any = [];
	TreeItems: TreeNode[] = [];

	cols = [{ field: "ApplicationItemName", header: "Name" }];

	CurrentFullRights: any = false;
	CurrentAccessRead = false;
	CurrentAccessUpdate = false;
	CurrentAccessInsert = false;
	CurrentAccessDelete = false;

	loading: any = false;

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////
	LoadApplicationItems() {
		this.loading = true;

		var result = this.menuService.getApplicationItems();
		result.subscribe(
			(response) => {
				this.ApplicationItems = response;

				this.UpdateTreeData();
			},
			(error) => {}
		);
	}

	UpdateTreeData() {
		for (var i = 0; i < this.ApplicationItems.length; i++) {
			var next = this.ApplicationItems[i];

			//Get parent items
			//Handle reports in another component
			if (
				next.IsParent == 1 &&
				String(next.ApplicationItemName).toLowerCase().indexOf("report") == -1 &&
				String(next.ApplicationItemName).toLowerCase().indexOf("favorites") == -1 &&
				String(next.ApplicationItemName).toLowerCase().indexOf("custom") == -1
			) {
				var lstChild: TreeNode[] = [];

				for (var x = 0; x < this.ApplicationItems[i].Children.length; x++) {
					var nextChild = this.ApplicationItems[i].Children[x];

					var nextChildNode: TreeNode = null;
					if (nextChild.Children.length == 0) {
						nextChildNode = {
							data: {
								ApplicationItemID: nextChild.ApplicationItemID,
								ApplicationItemName: nextChild.ApplicationItemName,
								FullRights: false,
								AccessRead: false,
								AccessUpdate: false,
								AccessInsert: false,
								AccessDelete: false,
							},
						};
					} else {
						var lstSubChildren: TreeNode[] = [];

						for (var z = 0; z < nextChild.Children.length; z++) {
							var nextSubChild = nextChild.Children[z];

							var nextSubChildNode: TreeNode = {
								data: {
									ApplicationItemID: nextSubChild.ApplicationItemID,
									ApplicationItemName: nextSubChild.ApplicationItemName,
									FullRights: false,
									AccessRead: false,
									AccessUpdate: false,
									AccessInsert: false,
									AccessDelete: false,
								},
							};

							lstSubChildren = [...lstSubChildren, nextSubChildNode];
						}

						nextChildNode = {
							data: {
								ApplicationItemID: nextChild.ApplicationItemID,
								ApplicationItemName: nextChild.ApplicationItemName,
								FullRights: false,
								AccessRead: false,
								AccessUpdate: false,
								AccessInsert: false,
								AccessDelete: false,
							},
							children: lstSubChildren,
						};
					}

					lstChild = [...lstChild, nextChildNode];
				}

				var nextNode: TreeNode = {
					data: {
						ApplicationItemID: next.ApplicationItemID,
						ApplicationItemName: next.ApplicationItemName,
						FullRights: false,
						AccessRead: false,
						AccessUpdate: false,
						AccessInsert: false,
						AccessDelete: false,
					},
					children: lstChild,
				};

				this.TreeItems = [...this.TreeItems, nextNode];
			}
		}

		this.UpdateAppItems();
	}

	UpdateAppItems() {
		if (this.AppItemsFromMain != undefined) {
			for (var i = 0; i < this.AppItemsFromMain.length; i++) {
				var nextApp = this.AppItemsFromMain[i];

				//Match items
				for (var x = 0; x < this.TreeItems.length; x++) {
					var nextNode = this.TreeItems[x];

					if (
						nextApp.ApplicationItemName == nextNode.data.ApplicationItemName ||
						String(nextApp.ApplicationItemID).toLowerCase() == String(nextNode.data.ApplicationItemID).toLowerCase()
					) {
						//Update data
						nextNode.data.AccessRead = nextApp.AccessRead == 1 ? true : false;
						nextNode.data.AccessUpdate = nextApp.AccessUpdate == 1 ? true : false;
						nextNode.data.AccessInsert = nextApp.AccessInsert == 1 ? true : false;
						nextNode.data.AccessDelete = nextApp.AccessDelete == 1 ? true : false;

						if (
							nextNode.data.AccessRead == true &&
							nextNode.data.AccessUpdate == true &&
							nextNode.data.AccessInsert == true &&
							nextNode.data.AccessDelete == true
						) {
							nextNode.data.FullRights = true;
						}

						break;
					}

					if (nextNode.children != undefined) {
						for (var z = 0; z < nextNode.children.length; z++) {
							var nextChild = nextNode.children[z];

							if (
								nextApp.ApplicationItemName == nextChild.data.ApplicationItemName ||
								String(nextApp.ApplicationItemID).toLowerCase() == String(nextChild.data.ApplicationItemID).toLowerCase()
							) {
								//Update data
								nextChild.data.AccessRead = nextApp.AccessRead == 1 ? true : false;
								nextChild.data.AccessUpdate = nextApp.AccessUpdate == 1 ? true : false;
								nextChild.data.AccessInsert = nextApp.AccessInsert == 1 ? true : false;
								nextChild.data.AccessDelete = nextApp.AccessDelete == 1 ? true : false;

								if (
									nextChild.data.AccessRead == true &&
									nextChild.data.AccessUpdate == true &&
									nextChild.data.AccessInsert == true &&
									nextChild.data.AccessDelete == true
								) {
									nextChild.data.FullRights = true;
								}

								break;
							}

							if (nextChild.children != undefined) {
								for (var q = 0; q < nextChild.children.length; q++) {
									var nextInnerChild = nextChild.children[q];

									if (
										nextApp.ApplicationItemName == nextInnerChild.data.ApplicationItemName ||
										String(nextApp.ApplicationItemID).toLowerCase() == String(nextInnerChild.data.ApplicationItemID).toLowerCase()
									) {
										//Update data
										nextInnerChild.data.AccessRead = nextApp.AccessRead == 1 ? true : false;
										nextInnerChild.data.AccessUpdate = nextApp.AccessUpdate == 1 ? true : false;
										nextInnerChild.data.AccessInsert = nextApp.AccessInsert == 1 ? true : false;
										nextInnerChild.data.AccessDelete = nextApp.AccessDelete == 1 ? true : false;

										if (
											nextInnerChild.data.AccessRead == true &&
											nextInnerChild.data.AccessUpdate == true &&
											nextInnerChild.data.AccessInsert == true &&
											nextInnerChild.data.AccessDelete == true
										) {
											nextInnerChild.data.FullRights = true;
										}

										break;
									}
								}
							}
						}
					}
				}
			}
		}

		// console.log(this.TreeItems);

		this.loading = false;
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Events
	///////////////////////////////////////////

	nodeSelect(val) {
		this.SelectedAppItem = val.node;

		this.UpdateCheck();
	}
	nodeUnselect(val) {
		this.SelectedAppItem = null;
	}

	UpdateCheck() {
		if (this.SelectedAppItem != null && this.SelectedAppItem != undefined) {
			this.CurrentFullRights = this.SelectedAppItem.data.FullRights;
			this.CurrentAccessRead = this.SelectedAppItem.data.AccessRead;
			this.CurrentAccessUpdate = this.SelectedAppItem.data.AccessUpdate;
			this.CurrentAccessInsert = this.SelectedAppItem.data.AccessInsert;
			this.CurrentAccessDelete = this.SelectedAppItem.data.AccessDelete;
		} else {
			this.CurrentFullRights = false;
			this.CurrentAccessRead = false;
			this.CurrentAccessUpdate = false;
			this.CurrentAccessInsert = false;
			this.CurrentAccessDelete = false;
		}

		if (this.SelectedAppItem != undefined) {
			if (this.SelectedAppItem.parent != undefined) {
				this.UpdateParent(this.SelectedAppItem.parent);
			}
		}
	}

	UpdateParent(parent) {
		if (parent != undefined) {
			//Set values to true if at least one child's value is true
			var FullRights = false;
			var AccessRead = false;
			var AccessUpdate = false;
			var AccessInsert = false;
			var AccessDelete = false;

			//Set values to false if at least 1 child is false
			// var FullRights = true;
			// var AccessRead = true;
			// var AccessUpdate = true;
			// var AccessInsert = true;
			// var AccessDelete = true;

			for (var i = 0; i < parent.children.length; i++) {
				var next = parent.children[i];

				if (next.data.FullRights == true) {
					FullRights = true;
				}
				if (next.data.AccessRead == true) {
					AccessRead = true;
				}
				if (next.data.AccessUpdate == true) {
					AccessUpdate = true;
				}
				if (next.data.AccessInsert == true) {
					AccessInsert = true;
				}
				if (next.data.AccessDelete == true) {
					AccessDelete = true;
				}

				// if(next.data.FullRights == false){
				//   FullRights = false;
				// }
				// if(next.data.AccessRead == false){
				//   AccessRead = false;
				// }
				// if(next.data.AccessUpdate == false){
				//   AccessUpdate = false;
				// }
				// if(next.data.AccessInsert == false){
				//   AccessInsert = false;
				// }
				// if(next.data.AccessDelete == false){
				//   AccessDelete = false;
				// }
			}

			//Only update if parent's data is false?
			// if(parent.data.FullRights == false){
			//   parent.data.FullRights = FullRights;
			// }
			// if(parent.data.AccessRead == false){
			//   parent.data.AccessRead = AccessRead;
			// }
			// if(parent.data.AccessUpdate == false){
			//   parent.data.AccessUpdate = AccessUpdate;
			// }
			// if(parent.data.AccessInsert == false){
			//   parent.data.AccessInsert = AccessInsert;
			// }
			// if(parent.data.AccessDelete == false){
			//   parent.data.AccessDelete = AccessDelete;
			// }

			parent.data.FullRights = FullRights;
			parent.data.AccessRead = AccessRead;
			parent.data.AccessUpdate = AccessUpdate;
			parent.data.AccessInsert = AccessInsert;
			parent.data.AccessDelete = AccessDelete;

			if (parent.data.AccessRead == true && parent.data.AccessUpdate == true && parent.data.AccessInsert == true && parent.data.AccessDelete == true) {
				parent.data.FullRights = true;
			}

			if (parent.parent != undefined) {
				this.UpdateParent(parent.parent);
			}
		}
	}

	DisableCheck() {
		this.UpdateCheck();
		return this.DisableControls == true || this.SelectedAppItem == null || this.SelectedAppItem == undefined;
	}

	onFullRightsChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable full rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "appitem",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateFullRights(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateFullRights(val);
		}
	}

	UpdateFullRights(val) {
		this.SelectedAppItem.data.FullRights = val;
		this.SelectedAppItem.data.AccessRead = val;
		this.SelectedAppItem.data.AccessUpdate = val;
		this.SelectedAppItem.data.AccessInsert = val;
		this.SelectedAppItem.data.AccessDelete = val;

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.FullRights = val;
				child.data.AccessRead = val;
				child.data.AccessUpdate = val;
				child.data.AccessInsert = val;
				child.data.AccessDelete = val;

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.FullRights = val;
						subChild.data.AccessRead = val;
						subChild.data.AccessUpdate = val;
						subChild.data.AccessInsert = val;
						subChild.data.AccessDelete = val;
					}
				}
			}
		}

		this.UpdateCheck();
	}

	onAccessReadChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable access rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "appitem",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateAccessRead(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateAccessRead(val);
		}
	}

	UpdateAccessRead(val) {
		this.SelectedAppItem.data.AccessRead = val;

		if (
			this.SelectedAppItem.data.AccessRead == true &&
			this.SelectedAppItem.data.AccessUpdate == true &&
			this.SelectedAppItem.data.AccessInsert == true &&
			this.SelectedAppItem.data.AccessDelete == true
		) {
			this.SelectedAppItem.data.FullRights = true;
		} else {
			this.SelectedAppItem.data.FullRights = false;
		}

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.AccessRead = val;
				if (child.data.AccessRead == true && child.data.AccessUpdate == true && child.data.AccessInsert == true && child.data.AccessDelete == true) {
					child.data.FullRights = true;
				} else {
					child.data.FullRights = false;
				}

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.AccessRead = val;

						if (
							subChild.data.AccessRead == true &&
							subChild.data.AccessUpdate == true &&
							subChild.data.AccessInsert == true &&
							subChild.data.AccessDelete == true
						) {
							subChild.data.FullRights = true;
						} else {
							subChild.data.FullRights = false;
						}
					}
				}
			}
		}

		this.UpdateCheck();
	}

	onAccessUpdateChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable update rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "appitem",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateAccessUpdate(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateAccessUpdate(val);
		}
	}

	UpdateAccessUpdate(val) {
		this.SelectedAppItem.data.AccessUpdate = val;

		if (
			this.SelectedAppItem.data.AccessRead == true &&
			this.SelectedAppItem.data.AccessUpdate == true &&
			this.SelectedAppItem.data.AccessInsert == true &&
			this.SelectedAppItem.data.AccessDelete == true
		) {
			this.SelectedAppItem.data.FullRights = true;
		} else {
			this.SelectedAppItem.data.FullRights = false;
		}

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.AccessUpdate = val;
				if (child.data.AccessRead == true && child.data.AccessUpdate == true && child.data.AccessInsert == true && child.data.AccessDelete == true) {
					child.data.FullRights = true;
				} else {
					child.data.FullRights = false;
				}

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.AccessUpdate = val;

						if (
							subChild.data.AccessRead == true &&
							subChild.data.AccessUpdate == true &&
							subChild.data.AccessInsert == true &&
							subChild.data.AccessDelete == true
						) {
							subChild.data.FullRights = true;
						} else {
							subChild.data.FullRights = false;
						}
					}
				}
			}
		}

		this.UpdateCheck();
	}

	onAccessInsertChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable insert rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "appitem",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateAccessInsert(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateAccessInsert(val);
		}
	}

	UpdateAccessInsert(val) {
		this.SelectedAppItem.data.AccessInsert = val;

		if (
			this.SelectedAppItem.data.AccessRead == true &&
			this.SelectedAppItem.data.AccessUpdate == true &&
			this.SelectedAppItem.data.AccessInsert == true &&
			this.SelectedAppItem.data.AccessDelete == true
		) {
			this.SelectedAppItem.data.FullRights = true;
		} else {
			this.SelectedAppItem.data.FullRights = false;
		}

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.AccessInsert = val;
				if (child.data.AccessRead == true && child.data.AccessUpdate == true && child.data.AccessInsert == true && child.data.AccessDelete == true) {
					child.data.FullRights = true;
				} else {
					child.data.FullRights = false;
				}

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.AccessInsert = val;

						if (
							subChild.data.AccessRead == true &&
							subChild.data.AccessUpdate == true &&
							subChild.data.AccessInsert == true &&
							subChild.data.AccessDelete == true
						) {
							subChild.data.FullRights = true;
						} else {
							subChild.data.FullRights = false;
						}
					}
				}
			}
		}

		this.UpdateCheck();
	}

	onAccessDeleteChange(val) {
		//Ask if user wants to apply changes to children
		if (this.SelectedAppItem.children != undefined) {
			var confirmMsg = "Do you want to enable delete rights on all child items of the " + this.SelectedAppItem.data.ApplicationItemName + " application?";

			this.confirmationService.confirm({
				key: "appitem",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: confirmMsg,
				header: "Access Rights",
				icon: "fa",
				accept: () => {
					this.UpdateAccessDelete(val);
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateAccessDelete(val);
		}
	}

	UpdateAccessDelete(val) {
		this.SelectedAppItem.data.AccessDelete = val;

		if (
			this.SelectedAppItem.data.AccessRead == true &&
			this.SelectedAppItem.data.AccessUpdate == true &&
			this.SelectedAppItem.data.AccessInsert == true &&
			this.SelectedAppItem.data.AccessDelete == true
		) {
			this.SelectedAppItem.data.FullRights = true;
		} else {
			this.SelectedAppItem.data.FullRights = false;
		}

		if (this.SelectedAppItem.children != undefined) {
			for (var i = 0; i < this.SelectedAppItem.children.length; i++) {
				var child = this.SelectedAppItem.children[i];

				child.data.AccessDelete = val;
				if (child.data.AccessRead == true && child.data.AccessUpdate == true && child.data.AccessInsert == true && child.data.AccessDelete == true) {
					child.data.FullRights = true;
				} else {
					child.data.FullRights = false;
				}

				if (child.children != undefined) {
					for (var z = 0; z < child.children.length; z++) {
						var subChild = child.children[z];
						subChild.data.AccessDelete = val;

						if (
							subChild.data.AccessRead == true &&
							subChild.data.AccessUpdate == true &&
							subChild.data.AccessInsert == true &&
							subChild.data.AccessDelete == true
						) {
							subChild.data.FullRights = true;
						} else {
							subChild.data.FullRights = false;
						}
					}
				}
			}
		}

		this.UpdateCheck();
	}

	///////////////////////////////////////////
}
